import type { FunctionComponent } from 'react';

import { Logo, Text } from '@kanda-libs/ks-design-library';
import { Title } from '@kanda-libs/ks-design-library-new';

import { CLASS_NAMES } from './constants';

import trustPilotImage from '../../../../assets/trustpilot.png';

export interface ApplyHeaderProps {
  title?: string;
  showSubTitle?: boolean;
}

const ApplyHeader: FunctionComponent<ApplyHeaderProps> = function ({
  title = 'Pay monthly',
  showSubTitle = true,
}) {
  return (
    <div className={CLASS_NAMES.wrapper}>
      <div className={CLASS_NAMES.titleWrapper}>
        <div className={CLASS_NAMES.title}>
          <Title>{title}</Title>
        </div>
        {showSubTitle && (
          <Text
            text="enter your details below"
            className={CLASS_NAMES.subTitle}
          />
        )}
      </div>
      <div className={CLASS_NAMES.logosWrapper}>
        <div className={CLASS_NAMES.poweredByKanda}>
          <span>Powered by</span> <Logo width={61} />
        </div>
        <img
          src={trustPilotImage}
          alt="Trust pilot, 4.8 stars, 300+ reviews"
          className={CLASS_NAMES.trustPilot}
        />
      </div>
    </div>
  );
};

export default ApplyHeader;
